module.exports = __webpack_public_path__ + "img/FSOP-all3.77a419e8.png";